const hasSelectedComparables = ({key, data,}) => {
    return data
        && !!data[key]
        && data[key].selected
        && data[key].selected.length > 0;
};

export const filteredSection = ({section = {}, data = {}}) => {
    if (!section.key) {
        return false;
    }
    if (section.key === 'COMPARABLE_MAP') {
        return hasSelectedComparables({key: 'comparableSales', data})
            && hasSelectedComparables({key: 'comparableListings', data});
    }
    if (['COMPARABLE_SALES', 'COMPARABLE_SALES_MAP'].indexOf(section.key) >= 0) {
        return hasSelectedComparables({key: 'comparableSales', data});
    }
    if (['COMPARABLE_LISTINGS', 'COMPARABLE_LISTINGS_MAP'].indexOf(section.key) >= 0) {
        return hasSelectedComparables({key: 'comparableListings', data});
    }
    if (['COMPARABLE_RENTALS', 'COMPARABLE_RENTALS_MAP'].indexOf(section.key) >= 0) {
        return hasSelectedComparables({key: 'comparableRentals', data});
    }
    return true;
};